export const errors = {
  somethingWentWrong: "Something went wrong",
  tryAgain: "Try again",
  errorFetchingData: "Error fetching data",
};
